import { legacyPath } from '@hbac/contract';
import { Navigate, useLocation } from 'react-router-dom';
import { publicPaths } from './paths';

/**
 * Catch-all route.
 *
 * A full page load of an old path is redirected by the Worker (301). This
 * covers the same old paths reached inside the app, e.g. a notification whose
 * link was stored before the rename, and sends anything else home.
 */
export function UnknownPath() {
  const { pathname, search, hash } = useLocation();
  const renamed = legacyPath(pathname);
  return <Navigate to={renamed ? `${renamed}${search}${hash}` : publicPaths.home} replace />;
}
